import { withTheme } from 'styled-components';

const index = ({ theme, color, height = '32px', width = '32px' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
      data-testid="other"
    >
      <g fill="none" fillRule="evenodd">
        <g fill={color || theme.primaryColor} fillRule="nonzero">
          <g>
            <g>
              <path
                d="M16.213 0c-1.56-.03-2.981.887-3.599 2.32-.617 1.432-.307 3.095.786 4.209 1.092 1.113 2.75 1.455 4.193.865 1.444-.59 2.388-1.994 2.388-3.554C20 1.74 18.314.021 16.213 0zm0 6.827c-1.214.03-2.325-.68-2.81-1.793-.485-1.113-.248-2.41.6-3.279.848-.87 2.138-1.138 3.263-.68 1.125.457 1.861 1.55 1.861 2.765.02 1.629-1.285 2.966-2.914 2.987zM4.194 0C2.634-.03 1.212.887.595 2.32c-.617 1.432-.307 3.095.786 4.209 1.092 1.113 2.749 1.455 4.193.865C7.018 6.804 7.96 5.4 7.962 3.84 7.98 1.74 6.294.021 4.194 0zm0 6.827c-1.214.03-2.325-.68-2.81-1.793-.486-1.113-.248-2.41.6-3.279.848-.87 2.138-1.138 3.263-.68 1.125.457 1.86 1.55 1.861 2.765.02 1.629-1.285 2.966-2.914 2.987zM28.233 0c-1.56-.03-2.982.887-3.6 2.32-.617 1.432-.306 3.095.786 4.209 1.092 1.113 2.75 1.455 4.193.865C31.056 6.804 32 5.4 32 3.84c.019-2.1-1.667-3.819-3.767-3.84zm0 6.827c-1.215.03-2.326-.68-2.811-1.793-.485-1.113-.248-2.41.6-3.279.848-.87 2.139-1.138 3.264-.68 1.125.457 1.86 1.55 1.86 2.765.02 1.629-1.284 2.966-2.913 2.987z"
                transform="translate(-245 -456) translate(245 456) translate(0 12)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default withTheme(index);
